<div class="col-12 d-flex text-center" [ngClass]="{ 'justify-content-center': isPositionedInCenter() }">
  @for (sparte of categories(); track sparte; let last = $last) {
    <div class="icon-text" [ngClass]="{ 'mr-3': !last }" data-test="invoice-card-icon">
      <img class="icon-small h-auto" [src]="sparte | categoryIconSrc" alt="{{ sparte | translateCategory }}" />
      <h6 class="m-1">{{ sparte | translateCategory }}</h6>
    </div>
  }
</div>
